
(function() {
  var result = { translations: { "ru": { "i18n": { "duration": { "seconds": "{{ seconds }} \u0441", "shortForm": { "minutes": "{{ minutes }}\u043C", "hours": "{{ hours }}\u0447", "days": "{{ days }}\u0434", "seconds": "{{ seconds }}\u0441", "hoursAndMinutes": "{{ hours }}\u0447 {{ minutes }}\u043C" }, "minutes": "{{ minutes }} \u043C\u0438\u043D", "hoursAndMinutes": "{{ hours }} \u0447 {{ minutes }} \u043C\u0438\u043D", "hours": "{{ hours }} \u0447", "days": "{{ days }} \u0434\u043D." }, "numberRepresentation": { "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "fraction": "{{ numerator }}/{{ denominator }}", "phoneNumberWithExtension": "{{phoneNumber}}, \u0434\u043E\u0431\u0430\u0432. {{extension}}" }, "dateTime": { "quarterAndYear": "\u041A\u0432.{{quarterNumber}} {{yearNumber}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ru": "static-7.990"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.990",
    "ar-eg": "static-7.990",
    "bg": "static-7.990",
    "bn": "static-7.990",
    "ca-es": "static-7.990",
    "cs": "static-7.990",
    "da": "static-7.990",
    "de": "static-7.990",
    "el": "static-7.990",
    "en-gb": "static-7.990",
    "en": "static-7.990",
    "es-mx": "static-7.990",
    "es": "static-7.990",
    "fi": "static-7.990",
    "fr-ca": "static-7.990",
    "fr": "static-7.990",
    "he-il": "static-7.990",
    "hr": "static-7.990",
    "hu": "static-7.990",
    "id": "static-7.990",
    "it": "static-7.990",
    "ja": "static-7.990",
    "ko": "static-7.990",
    "lt": "static-7.990",
    "ms": "static-7.990",
    "nl": "static-7.990",
    "no": "static-7.990",
    "pl": "static-7.990",
    "pt-br": "static-7.990",
    "pt-pt": "static-7.990",
    "ro": "static-7.990",
    "ru": "static-7.990",
    "sk": "static-7.990",
    "sl": "static-7.990",
    "sv": "static-7.990",
    "th": "static-7.990",
    "tl": "static-7.990",
    "tr": "static-7.990",
    "uk": "static-7.990",
    "vi": "static-7.990",
    "x-pseudo": "static-7.990",
    "zh-cn": "static-7.990",
    "zh-hk": "static-7.990",
    "zh-tw": "static-7.990"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ru', {version: 'static-7.990'}); }
})();


